import React from 'react';
import FacebookIcon from '../assets/facebook-icon.svg';
import WhatsappIcon from '../assets/whatsapp-icon.svg';
import PinterestIcon from '../assets/pinterest-icon.svg';
import EmailIcon from '../assets/mail-icon.svg';
import * as styles from './SocialShare.module.css';

import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  PinterestShareButton,
} from 'react-share';

const SocialShare = ({ url, lessonTitle, onShare }) => {
  const shareText = `Encontrei essa aula do AprendiZAP sobre ${lessonTitle}. Gostaria de compartilhar com você!`;

  return (
    <section id="social-share" className={styles.sectionShare}>
      <p className={styles.titleShare}>Compartilhar:</p>
      <FacebookShareButton
        beforeOnClick={() => {
          onShare('facebook');
        }}
        quote={shareText}
        url={url + '?utm_origin=facebook'}
        aria-label="Facebook"
      >
        <div className={styles.borderIcons}>
          <img src={FacebookIcon} className={styles.iconSize} alt="" />
        </div>
      </FacebookShareButton>
      <WhatsappShareButton
        beforeOnClick={() => {
          onShare('whatsapp');
        }}
        title={shareText}
        url={url + '?utm_origin=whatsapp'}
        aria-label="Whatsapp"
      >
        <div className={styles.borderIcons}>
          <img src={WhatsappIcon} className={styles.iconSize} alt="" />
        </div>
      </WhatsappShareButton>

      <PinterestShareButton
        beforeOnClick={() => {
          onShare('pinterest');
        }}
        title={shareText}
        url={url + '?utm_origin=pinterest'}
        media={url + '?utm_origin=pinterest'}
        aria-label="Pinterest"
      >
        <div className={styles.borderIcons}>
          <img src={PinterestIcon} className={styles.iconSize} alt="" />
        </div>
      </PinterestShareButton>
      <EmailShareButton
        beforeOnClick={() => {
          onShare('email');
        }}
        subject={shareText}
        url={url + '?utm_origin=email'}
        aria-label="Email"
      >
        <div className={styles.borderIcons}>
          <img src={EmailIcon} className={styles.iconSize} alt="" />
        </div>
      </EmailShareButton>
    </section>
  );
};

export default SocialShare;
